import { useEffect } from "react";
import { Button } from "@ziolo/ui";
import { WyplataReceiptCard } from "./WyplataReceiptCard.js";
import type { WypłataReceiptData } from "./wyplataReceipt.js";

export function WyplataReceiptOverlay({
  data,
  printing = true,
  onClose,
}: {
  data: WypłataReceiptData;
  /** Fresh wypłata animates out of the slot; history opens already printed. */
  printing?: boolean;
  onClose: () => void;
}) {
  useEffect(() => {
    function onKey(event: KeyboardEvent) {
      if (event.code === "Escape") onClose();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div
      className="wyplata-overlay"
      role="dialog"
      aria-label="Kupon wypłaty kaucji"
      onClick={onClose}
      ref={(node) => {
        if (node) node.scrollTop = 0;
      }}
    >
      <div className="wyplata-stage" onClick={(event) => event.stopPropagation()}>
        <div className="wyplata-stage__scroll">
          {printing ? (
            <div className="wyplata-slot" aria-hidden="true">
              <span className="wyplata-slot__lip" />
            </div>
          ) : null}
          <div className={`wyplata-printer${printing ? "" : " wyplata-printer--static"}`}>
            <WyplataReceiptCard data={data} animated={printing} />
          </div>
        </div>
        <Button
          variant="primary"
          className={`wyplata-overlay__ok${printing ? "" : " is-static"}`}
          onClick={onClose}
        >
          Schowaj kupon
        </Button>
      </div>
    </div>
  );
}
